<template>
    <div class="column is-9">
        <section class="hero is-info welcome is-small">
            <div class="hero-body">
                <div class="container">
                    <h1 class="title">
                        Bienvenid@,
                        <br>
                        {{user.name | capitalize }}
                    </h1>
                    <h2 class="subtitle">
                        Esperamos que tenga un gran día!
                    </h2>
                </div>
            </div>
        </section>
        
        <section class="info-tiles">
            <div class="tile is-ancestor has-text-centered">
                <div class="tile is-parent">
                    <article class="tile is-child box">

                        <div class="columns">
                            <div class="column is-6">
                                <div class="card events-card">
                                    <div class="card-content">

                                        <header class="card-header has-background-white-ter">
                                            <p class="card-header-title">
                                                Estado de Cuenta
                                            </p>                                            
                                        </header>

                                        <div class="content mt-15">
                                            <div v-if="accountAmount > 0" class="notification is-danger">
                                                <strong>Esta cuenta posee pagos pendientes</strong> 
                                                <br>
                                                <h4 class="has-text-warning">Saldo: $ {{accountAmount}}</h4>
                                            </div>

                                            <div v-else class="notification is-success">
                                                <strong>
                                                    Esta cuenta no posee pagos pendientes
                                                </strong>
                                            </div>
                                            <div class="seuo">*S.E.U.O.</div>

                                            <div v-if="accountPeriodsCount > 0" class="content mt-15">
                                                <hr>
                                                <h3>Cupones de Pago a Descargar</h3>
                                                <p>
                                                    <small>
                                                        Para abonar en Santa Fe Servicios
                                                    </small>                                                    
                                                </p>

                                                <div class="table-container">                             
                                                    <table class="table-profile">
                                                        <tbody>
                                                            <tr v-for="(cupon, index) in accountPeriods" :key="index">
                                                                <td>Cupón de pago {{ cupon.Periodo }}</td>
                                                                <td class="level-right">
                                                                    <a class="button is-small is-info"
                                                                        @click="attemptGetDocument(cupon.Periodo, 'coupon')">Descargar</a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="column is-6">
                                <div class="card">
                                    <div class="card-content">
                                        <header class="card-header has-background-white-ter">
                                            <p class="card-header-title">
                                                Otros Medios de Pago
                                            </p>                                            
                                        </header>

                                        <div class="content mt-15 table-wrapper">
                                            <h3>Transferencia bancaria</h3>
                                            <p>
                                                <small>
                                                    Imprescindible enviar comprobante a tssantafesur@gmail.com
                                                </small>
                                            </p>

                                            <table class="table-profile">
                                                <tbody>
                                                    <tr>
                                                        <th colspan="2">Banco Santa Fe</th>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2">Colegio de Profesionales de Trabajo Social</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Caja De Ahorro:</td>
                                                        <td>20984/08</td>
                                                    </tr>
                                                    <tr>
                                                        <td>CBU:</td>
                                                        <td>3300000620000020984089</td>
                                                    </tr>
                                                    <tr>
                                                        <td>CUIT:</td>
                                                        <td>30-67745627-9</td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <h3>Homebanking</h3>
                                            <p>
                                                <small>
                                                    <a href="https://drive.google.com/file/d/1UkFEb4n-29dWAKKxB1afMqvDGfSwHJlV/view?usp=sharing" target="_blank">
                                                        Descargar instrucciones
                                                        </a>                                                    
                                                </small>
                                            </p>
                                            
                                            <h3>Tarjeta de Crédito o Débito</h3>
                                            <p>
                                                <small>
                                                    <a href="https://www.mercadopago.com.ar/checkout/v1/redirect?pref_id=104784214-a8f8effb-ff17-4214-b34c-19e4ca708241">
                                                        Pagar desde MercadoPago
                                                    </a>                                                    
                                                </small>
                                            </p>
                                        </div>
                                    </div>
                                </div>                                            
                            </div>
                        </div>
                        <div class="seuo">* Salvo Error U Omisión. Ante inconsistencias consultar por mail al Colegio <a href="mailto:tssantafesur@gmail.com">tssantafesur@gmail.com</a></div>
                    </article>
                </div>                
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'dashboard',
    computed: {
        ...mapGetters({
            user: 'auth/user',
            errors: 'auth/errors',
            accountAmount: 'accountStatus/accountAmount',
            accountPeriods: 'accountStatus/accountPeriods',
            accountPeriodsCount: 'accountStatus/accountPeriodsCount'
        }),
    },
    methods:{
        ...mapActions({
            getDocument: 'documents/getDocument'
        }),

        attemptGetDocument(docName, docType){
            let data = { docName, docType };
            this.getDocument(data).catch((e) => {
                console.log(e);
            })
        }
    }
}
</script>
<style>
.table-container{
    overflow-y: auto;
    max-height: 200px;
}
.table-wrapper{
    overflow-x: auto;
}
.mt-15{
    margin-top: 15px;
}
.notification.is-success, .notification.is-danger{
    margin-bottom: 0px;
}
.notification.is-danger h4 {
    margin-top: 5px;
    
}
.seuo{
    font-size: 10px;
    text-align: left;
}
</style>